import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  GiftIcon,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import MultiSearch from "../components/MultiSearch";
import ReDesignAttribute from "../components/ReDesignAttribute";
import { getGiftOrders } from "../api/api";
import { excelHeaderCellsName } from "../lib/options";
import { useGiftOrdersPage } from "../hooks";
import { SmsBalanceAlert } from "@/shared/components";

const Page = () => {
  const {
    data,
    columns,
    isLoading,
    error,
    totalItems,
    search,
    updateSearch,
    handleSearchSubmit,
    handleSearchReset,
    pg,
    updatePg,
    refetch,
    getSmsBalance,
    attribute,
  } = useGiftOrdersPage();

  return (
    <>
      <ErrorAlert reload={refetch} show={error} />
      <SmsBalanceAlert isShow={getSmsBalance} />

      <Breadcrumb links={[{ name: "بيانات الإهداءات" }]} />

      <ReDesignAttribute row={attribute} refetch={refetch} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الإهداءات / الطلبات"
          title="بيانات الإهداءات"
          count={totalItems}
          icon={GiftIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <TableRowsPerPage
            pagination={{ ...pg, rows: totalItems }}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />

          <DownloadExcel
            length={data?.length}
            search={search.values}
            fetch={getGiftOrders}
            headerCellsName={excelHeaderCellsName}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={handleSearchSubmit}
          onReset={handleSearchReset}
          updateSearch={updateSearch}
          dataLength={data?.length}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={{ ...pg, rows: totalItems }}
          onPageChange={(page: number) => updatePg({ page })}
          onPageSizeChange={(size: number) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Page;
